import { LEGACY_ROUTES_MAPPING } from '@provision/portal-routes';
import { Route } from 'react-router-dom';
import { NavigateWithParams } from 'src/components';
import { getRoutePath } from 'src/routes/utils';

export const LegacyRouteRedirects = ({ relative }: { relative?: boolean }) => {
  return (
    <>
      {Object.entries(LEGACY_ROUTES_MAPPING).map(([from, to]) => (
        <Route
          key={from}
          path={getRoutePath(from, relative)}
          element={<NavigateWithParams to={getRoutePath(to, relative)} />}
        />
      ))}
    </>
  );
};
